export enum NotificationStatus {
  UNREAD = 'Unread',
  READ = 'Read',
}
export interface Notification {
  actionUrlOpt: string; // URL
  category: string; // enum?
  contextTimeStamp: number;
  createdAt: number | Date;
  description: string;
  id: number;
  level: string; // enum?
  occurrenceCount: number;
  projectId: number;
  title: string;
  updatedAt: number | Date;
}

export interface NotificationCount {
  total: number;
  totalRead: number;
  totalUnread: number;
}

export interface NotificationIds {
  notificationId: number;
  status: string;
}

export interface Filters {
  orderBy: string;
  page: number;
  pageSize: number;
  sortDesc: boolean;
  status: NotificationStatus;
}

export interface NotificationItem {
  notification: Notification;
  status: NotificationStatus;
}

export interface NotificationsState {
  notifications: NotificationItem[];
  notificationCount: NotificationCount;
  filters: Filters;
  isLoading: boolean;
}
